import type { $ } from "../../../dom";
import { CheckboxGroupInput, type CheckboxGroupInputOptions } from "../base";
import { SimpleCheckboxInput } from "./simple-checkbox-input";

export type SimpleCheckboxGroupInputOptions =
  CheckboxGroupInputOptions<string> & {
    instantiateInputs?: ($root: $) => SimpleCheckboxInput[];
  };

export class SimpleCheckboxGroupInput extends CheckboxGroupInput<
  string | null
> {
  public inputs: SimpleCheckboxInput[] = [];

  protected readonly inputFactory: () => SimpleCheckboxInput[];

  constructor($root: $, options: SimpleCheckboxGroupInputOptions = {}) {
    const { instantiateInputs, ...superOptions } = options;

    super($root, superOptions);

    this.inputFactory = instantiateInputs
      ? () => instantiateInputs(this.$root)
      : () =>
          this.$root.children.map(
            (element) => new SimpleCheckboxInput(this.$root.make(element)),
          );

    this.bindInputs();
  }
}
